import * as React from 'react';

/**
 *
 * IspRefine component
 * @extends {React.Component}
 */
class IspRefine extends React.Component <IAppProps, IAppState> {
    /* tslint:disable:no-string-literal */
    public handleOnClick = (event: React.MouseEvent<HTMLElement>) => {
        if (window['isp_switch_mode'] !== undefined) {
            window['isp_switch_mode'](event.currentTarget.dataset.arg);
        }
    }
    /* tslint:enable:no-string-literal */

    public render(): JSX.Element | null {
        return (
            <>
                <a
                        id={this.props.id}
                        data-arg={this.props.id}
                        role='button'
                        className={this.props.id}
                        onClick={this.handleOnClick}
                >
                        <img
                            role='presentation'
                            src='https://cdn1-gae-ssl-default.akamaized.net/images/isp_icon_navigation_16x16.png'
                            id='isp_watermark_img'
                            alt=''
                        />
                        <span id='isp_refine_button' className='isp_refine_navigation_content'>Refine</span>
                </a>
            </>
        );
    }
}

interface IAppProps {
    id: string;
}

interface IAppState {
    name: string;
}

export default IspRefine;